import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'

export type RemoveNginxSettingAction = FSA<undefined, number, string>
type RemoveNginxSetting = (nginxSettingId: number) => MrxThunk<RemoveNginxSettingAction, Promise<boolean>>
type QueryResponse = GraphQLResponse<'removeNginxSetting', boolean>

const REMOVE_NGINX_SETTING = `
  mutation removeNginxSetting ($nginxSettingId: Int!) {
    removeNginxSetting (nginxSettingId: $nginxSettingId)
  }
`

const removeNginxSetting: RemoveNginxSetting = (nginxSettingId) => async (dispatch) => {
  let isRemoved = false

  dispatch({
    type: t.REMOVE_NGINX_SETTING,
    meta: { done: false }
  })

  try {
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: REMOVE_NGINX_SETTING,
      variables: { nginxSettingId }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Empty response!')
    }

    const { removeNginxSetting } = data
    if (!removeNginxSetting) {
      throw new Error("Can't remove nginx setting!")
    }

    dispatch({
      type: t.REMOVE_NGINX_SETTING,
      payload: nginxSettingId,
      meta: { done: true }
    })

    isRemoved = true
  } catch (err) {
    dispatch({
      type: t.REMOVE_NGINX_SETTING,
      payload: extractErrorInfo(err),
      error: true
    })
  }

  return isRemoved
}

export { removeNginxSetting }
